import { fork } from 'redux-saga/effects';

import commonSaga from 'modules/common/sagas';
import generalSaga from 'modules/general/sagas';
import accountManagementSaga from 'modules/accountManagement/sagas';
import membersSaga from 'modules/members/sagas';

function* rootSaga() {
  yield fork(commonSaga);
  yield fork(generalSaga);
  yield fork(accountManagementSaga);
  yield fork(membersSaga);
}

export default rootSaga;
